import type { ReactNode } from 'react'

import { useVacationVibeEntry } from '@/components/Packages/SearchForm/useVacationVibeEntry'
import useBootstrapData from '@/hooks/useBootstrapData'
import type { ProductType } from '@/types'

type HomepageBumperSlotProps = Readonly<{
  productType: ProductType
  children: ReactNode
}>

/** Drop the spaced bumper wrapper when the vacation vibe banner replaces the savings line. */
export function HomepageBumperSlot({ productType, children }: HomepageBumperSlotProps) {
  const { isMobile } = useBootstrapData()
  const showVacationVibeEntry = useVacationVibeEntry({
    pageName: 'homepage',
    isMobile,
    shouldFireImpression: false,
  })

  if (productType === 'vacations' && showVacationVibeEntry) return null

  return children
}
